import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#64748B",
  "fill-rule": "evenodd",
  d: "m3 0 .806 2.194L6 3l-2.194.806L3 6l-.806-2.194L0 3l2.194-.806zm10.5 15 .672 1.828L16 17.5l-1.828.672L13.5 20l-.672-1.828L11 17.5l1.828-.672zM11.78 2.319a.5.5 0 0 0-.234-.25v-.002a.59.59 0 0 0-.67.09l-8.727 8.5a.5.5 0 0 0-.14.256.46.46 0 0 0 .036.285c.042.09.112.166.2.22a.6.6 0 0 0 .3.082h3.626l-1.965 5.853a.46.46 0 0 0 .013.329.5.5 0 0 0 .234.25.59.59 0 0 0 .671-.09l8.727-8.499a.5.5 0 0 0 .14-.256.46.46 0 0 0-.036-.285.5.5 0 0 0-.2-.22.6.6 0 0 0-.3-.082H9.828l1.965-5.852a.46.46 0 0 0-.013-.33",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }